<template>
  <div ref="container" class="absolute inset-0 flex flex-col space-y-4 items-center justify-center z-50"
       :style="colors">
    <UtilityProfileInitials :avatar="typeformData.avatar" :name="typeformData.name" class="h-14 w-14"
                            bg-class="bg-white bg-opacity-25"
                            color-class=" " :class="animateClass"/>
    <div class="h-1.5 w-48 mt-16 rounded-sm relative overflow-hidden" :class="animateClass"
         style="--anim-delay: 100ms; --from-transform-y: 0;">
      <div class="absolute inset-0" :style="complimentFaint"/>
      <div class="loading-bar rounded-sm" :style="complimentFull"/>
    </div>
  </div>
</template>

<script setup>
import {computed, inject, onMounted, ref} from "vue";
import UtilityProfileInitials from "./UtilityProfileInitials.vue";
import {useAnimateInTrigger} from "../composables/AnimateInComposable";

const typeformData = inject("typeformData", {});

const container = ref(null);

const colors = computed(() => `background-color:${typeformData.secondaryBackground};color:${typeformData.secondaryForeground}`);
const complimentFaint = computed(() => `background-color:${typeformData.secondaryForeground};opacity:0.25;`);
const complimentFull = computed(() => `background-color:${typeformData.secondaryForeground};opacity:0.8;`);

const animateClass = ref("animate-in-vars-pre");

useAnimateInTrigger(container, (className) => animateClass.value = className);

onMounted(() => setTimeout(() => animateClass.value = "animate-in-vars", 50));
</script>
